import { render } from "./ViewPayrollSummaryReport.vue?vue&type=template&id=67e24622&scoped=true"
import script from "./ViewPayrollSummaryReport.vue?vue&type=script&lang=js"
export * from "./ViewPayrollSummaryReport.vue?vue&type=script&lang=js"

import "./ViewPayrollSummaryReport.vue?vue&type=style&index=0&id=67e24622&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67e24622"]])

export default __exports__